import {
  GenerateHikStorageRequest,
  GenerateHikStorageResponse,
  GenerateLassieMiniRequest,
  GenerateLassieMiniResponse,
  GenerateLassieRequest,
  GenerateLassieResponse,
  GenerateShuttleRequest,
  GenerateShuttleResponse,
} from '@thive/fddm-types';

import { getConfig } from '@/modules/common/helpers/config';
import { API_TIMEOUTS } from '../constant';
import { BaseConnector } from '@/modules/api/BaseConnector';
import { ITemplateApiConnector } from './ITemplateApiConnector';

export class TemplateApiConnector extends BaseConnector implements ITemplateApiConnector {
  private static instance: TemplateApiConnector;
  private static baseUrl = getConfig().api.templateService.url;
  private static scopes = [getConfig().api.templateService.scope];

  public static getInstance(): ITemplateApiConnector {
    if (!TemplateApiConnector.instance) {
      TemplateApiConnector.instance = new TemplateApiConnector();
    }
    return TemplateApiConnector.instance;
  }

  private constructor() {
    super(TemplateApiConnector.baseUrl, TemplateApiConnector.scopes, API_TIMEOUTS.templateService);
  }

  async generateLassie(
    parameters: GenerateLassieRequest,
    requestKey?: string,
  ): Promise<GenerateLassieResponse> {
    return this.post<GenerateLassieResponse, GenerateLassieRequest>('/generateLassie', parameters, {
      requiredErrorMessage: 'Invalid response: design is missing',
      requestKey,
    });
  }

  async generateLassieMini(
    parameters: GenerateLassieMiniRequest,
    requestKey?: string,
  ): Promise<GenerateLassieMiniResponse> {
    return this.post<GenerateLassieMiniResponse, GenerateLassieMiniRequest>(
      '/generateLassieMini',
      parameters,
      {
        requiredErrorMessage: 'Invalid response: design is missing',
        requestKey,
      },
    );
  }

  async generateShuttle(
    parameters: GenerateShuttleRequest,
    requestKey?: string,
  ): Promise<GenerateShuttleResponse> {
    return this.post<GenerateShuttleResponse, GenerateShuttleRequest>(
      '/generateShuttleRacks',
      parameters,
      {
        requiredErrorMessage: 'Invalid response: design is missing',
        requestKey,
      },
    );
  }

  async generateHik(
    parameters: GenerateHikStorageRequest,
    requestKey?: string,
  ): Promise<GenerateHikStorageResponse> {
    return this.post<GenerateHikStorageResponse, GenerateHikStorageRequest>(
      '/generateHikStorage',
      parameters,
      {
        requiredErrorMessage: 'Invalid response: design is missing',
        requestKey,
      },
    );
  }
}
